import type { ReferralStore } from './interfaces'

import { formatWholePrice } from '@helpers/price'

export const getters = {
  isLoading: (state: ReferralStore): ReferralStore['loading'] => state.loading,
  isLoaded: (state: ReferralStore): ReferralStore['loaded'] => state.loaded,
  isFirstLoading: (state: ReferralStore): boolean => state.loading && !state.loaded,
  isInviteProcessing: (state: ReferralStore): ReferralStore['inviteProcessing'] => state.inviteProcessing,
  isCreditsAnimation: (state: ReferralStore): ReferralStore['creditsAnimation'] => state.creditsAnimation,
  isBalanceAnimation: (state: ReferralStore): ReferralStore['balanceAnimation'] => state.balanceAnimation,
  getBalance: (state: ReferralStore): ReferralStore['balance'] => state.balance,
  getPreviousBalance: (state: ReferralStore): ReferralStore['previousBalance'] => state.previousBalance,
  getReferralLink: (state: ReferralStore): ReferralStore['referralLink'] => state.referralLink,
  getDisplayReferralLink: (state: ReferralStore): string => state.referralLink.replace(/^https?:\/\//, ''),
  getSavings: (state: ReferralStore): ReferralStore['savings'] => state.savings,
  getReferrals: (state: ReferralStore): ReferralStore['referrals'] => state.referrals,
  getFormattedBalance: (state: ReferralStore): string => formatWholePrice(state.balance),
  getShareMessage: (state: ReferralStore): string => `Join me on Brighterly and get 25% off your first purchase: ${state.referralLink}`,
}
